module.exports = __webpack_public_path__ + "static/media/PasanSenevirathne.a41aa740.jpeg";